export const TOAST_DURATION = {
  SHORT: 3000,
  DEFAULT: 4000,
  LONG: 6000,
  VERY_LONG: 8000,
} as const;

export const TOAST_CONFIG = {
  SUCCESS: {
    duration: TOAST_DURATION.DEFAULT,
  },
  ERROR: {
    duration: TOAST_DURATION.LONG,
  },
  WARNING: {
    duration: TOAST_DURATION.LONG,
  },
  INFO: {
    duration: TOAST_DURATION.SHORT,
  },
  LOADING: {
    duration: TOAST_DURATION.VERY_LONG,
  },
} as const;

export const CACHE_TIME = {
  SHORT: 1 * 60 * 1000,
  DEFAULT: 5 * 60 * 1000,
  LONG: 15 * 60 * 1000,
  HOUR: 60 * 60 * 1000,
} as const;

export const STORAGE_KEYS = {
  IS_AUTHENTICATED: 'isAuthenticated',
  USER: 'user',
  ACCESS_TOKEN: 'accessToken',
  MY_EVENTS: 'myEvents',
  SELECTED_MEMBERS: 'selectedMembers',
} as const;

export const DATE_FORMAT_OPTIONS = {
  FULL_DATE: {
    weekday: 'long' as const,
    month: 'short' as const,
    day: 'numeric' as const,
  },
  LOCALE: 'en-US',
} as const;

export const DATE_LABELS = {
  TODAY: 'Today',
  TOMORROW: 'Tomorrow',
  UPCOMING: 'Upcoming',
} as const;

export const TIME_CONSTANTS = {
  HOURS_IN_DAY: 24,
  MILLISECONDS_IN_DAY: 24 * 60 * 60 * 1000,
  RESET_TIME: {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  },
} as const;

export const API_TIMEOUT = {
  SHORT: 5000,
  DEFAULT: 10000,
  LONG: 30000,
} as const;

export const QUERY_CONFIG = {
  RETRY_COUNT: 2,
  REFETCH_ON_FOCUS: false,
} as const;
